import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChartAtaProps } from './BarChartAta';

export const BarChartAta = loadableWithFallback<BarChartAtaProps>(() => import('./BarChartAta'));
